import { useState } from 'react';

export const useCheckbox = () => {
  const [checked, changeChecked] = useState(false);
  const handleChange = (e) => {
    changeChecked(e.target.checked);
  };
  return [checked, handleChange];
};
